export const enMessages = {
  "lang.en": "English",
  "lang.vi": "Vietnamese",
  "nav.contact": "Contact",
  "nav.home": "Home",
  "nav.support": "Technical support",
  "nav.openMenu": "Open menu",
  "nav.closeMenu": "Close menu",
  "breadcrumb.home": "Home",
  "breadcrumb.news": "News",
  "news.title": "News",
  "news.description": "VIVOO product news, camera technology updates, and information about video management deployments.",
  "news.metaTitle": "News",
  "news.metaDescription": "Follow VIVOO product releases, AI camera technology, and video management for business operations.",
  "news.empty": "No news articles are available yet.",
  "news.noContent": "No detailed content available for this article.",
  "news.readMore": "Read more",
  "news.viewAll": "View all news",
  "news.ctaTitle": "Planning a video security project?",
  "news.ctaDescription": "Send your questions about camera models, system integration, or deployment to the VIVOO team.",
  "news.ctaButton": "Contact us",
  "catalog.compareProducts": "COMPARE PRODUCTS",
  "hero.getPricing": "GET PRICING",
  "product.learnMore": "View product",
  "product.viewAll": "View all products",
  "solutions.viewAll": "View all solutions",
  "contact.title": "Discuss your system design and deployment",
  "contact.description": "Tell us about your AI camera, video management, or integration requirements. VIVOO will work with you to define the configuration and project scope.",
  "contact.pageTitle": "Contact VIVOO",
  "contact.ctaDetails": "Share your site, camera count, network infrastructure, and monitoring objectives so the VIVOO team can prepare a focused consultation.",
  "contact.pageDescription": "Tell us about your site, existing equipment, and technical requirements. The VIVOO team will recommend a suitable system configuration and deployment approach.",
  "contact.firstName": "First name*",
  "contact.lastName": "Last name*",
  "contact.workEmail": "Work email*",
  "contact.phoneNumber": "Phone number*",
  "contact.companyName": "Company name*",
  "contact.postalCode": "Postal code*",
  "contact.optionalMessage": "Optional: Describe your site, system size, or technical requirements",
  "contact.submit": "SUBMIT",
  "contact.sending": "Sending...",
  "contact.requiredField": "Please complete this required field.",
  "contact.thankYou": "Thank you!",
  "contact.successMessage": "Your message has been sent successfully. We will get back to you as soon as possible.",
  "contact.backHome": "Back to Home",
  "support.metaTitle": "VIVOO Technical Support",
  "support.metaDescription": "Get camera configuration guidance, troubleshooting, warranty checks, and VIVOO system deployment support.",
  "support.eyebrow": "VIVOO technical support",
  "support.title": "Configuration guidance, troubleshooting, and device service",
  "support.description": "Choose a topic: camera connectivity, image quality, recording, alerts, app access, warranty, or project deployment. Include the model and issue details to speed up diagnosis.",
  "support.requestSupport": "Request support",
  "support.callNow": "Call now",
  "support.phone": "Phone",
  "support.email": "Email",
  "support.hours": "Working hours",
  "support.address": "Address",
  "support.topicTitle": "Select a support topic",
  "support.topicDescription": "Choose a category to find the right support path, from device configuration and connectivity to warranty and on-site deployment.",
  "support.topic.technical.title": "Technical troubleshooting",
  "support.topic.technical.description": "Support for camera connectivity, image quality, recording, alerts, network settings and system health checks.",
  "support.topic.warranty.title": "Warranty and service",
  "support.topic.warranty.description": "Guidance for warranty status, replacement requests, maintenance planning and service documentation.",
  "support.topic.documents.title": "Documents and manuals",
  "support.topic.documents.description": "Request datasheets, installation guides, configuration notes, firmware references and project handover files.",
  "support.topic.app.title": "App and account help",
  "support.topic.app.description": "Help with mobile app access, user permissions, password recovery, notification settings and remote viewing.",
  "support.topic.project.title": "Deployment support",
  "support.topic.project.description": "Assistance for site surveys, device selection, installation coordination, acceptance testing and operator training.",
  "support.topic.remote.title": "Remote assistance",
  "support.topic.remote.description": "Share your issue details and our team will review logs, settings and symptoms to recommend the fastest fix.",
  "support.processTitle": "Support process",
  "support.processDescription": "Include the site name, model and serial number, firmware version if available, when the issue occurred, and relevant photos or screenshots.",
  "support.step.1": "Send your request through the contact form, phone or email with the basic site and device information.",
  "support.step.2": "Our team confirms the issue, checks warranty or service scope and prioritizes the request.",
  "support.step.3": "We provide remote guidance first, then schedule an on-site visit when physical inspection is needed.",
  "support.step.4": "After the issue is resolved, we summarize the action taken and recommend preventive checks if necessary.",
  "support.faqTitle": "Support FAQs",
  "support.faqDescription": "Find the information to prepare and common steps for configuring and operating VIVOO devices.",
  "support.faq.q1.question": "What information should I prepare before requesting support?",
  "support.faq.q1.answer": "Please prepare your company or site name, contact person, phone number, product model, issue description and related photos or screenshots.",
  "support.faq.q2.question": "Can Vivoo support remote troubleshooting?",
  "support.faq.q2.answer": "Yes. For many software, configuration and connectivity issues, our team can guide you remotely before scheduling an on-site visit.",
  "support.faq.q3.question": "How do I request warranty support?",
  "support.faq.q3.answer": "Send the product model, serial number if available, purchase or project information and a short description of the issue so we can verify the warranty scope.",
  "support.faq.q4.question": "Do you provide installation and training support?",
  "support.faq.q4.answer": "Yes. We can coordinate deployment assistance, acceptance testing and basic operator training depending on your project scope.",
  "footer.products": "Products",
  "footer.solutionsAndServices": "Solutions & Services",
  "footer.contactUs": "Contact Us",
  "resources.title": "Resources",
  "resources.description": "Download camera configuration tools, installation documents, datasheets, and firmware for VIVOO deployment and maintenance.",
  "resources.cameraConfig.title": "Camera Configuration Tool",
  "resources.cameraConfig.description": "Configure your cameras, apply common settings to multiple cameras or adjust individual cameras to fit your site requirements.",
  "resources.accessories.title": "Camera Accessories",
  "resources.accessories.description": "View technical documents such as installation guides and datasheets for camera accessories.",
  "resources.discontinued.title": "Discontinued Products",
  "resources.discontinued.description": "View technical documents and firmware for cameras and sensors that have been discontinued.",
  "resources.learnMore": "Learn More",
  "breadcrumb.solutions": "Solutions",
  "toc.title": "Table of Contents",
  "sidebar.interestedTitle": "Interested in this solution?",
  "sidebar.interestedDescription": "Discuss your coverage requirements, device configuration, and integration scope with VIVOO.",
  "sidebar.requestQuote": "REQUEST A QUOTE",
  "service.tag": "Service",
  "service.interestedTitle": "Interested in this service?",
  "service.interestedDescription": "Share the project scope, site location, and equipment to determine the right service approach.",
  "service.requestQuote": "REQUEST A QUOTE",
  "service.noContent": "No detailed content available for this service.",
  "breadcrumb.services": "Services",
  "productGrid.title": "Cameras and video security devices",
  "productGrid.description": "Browse VIVOO AI cameras, recording devices, and accessories with technical details to support system selection and design.",
  "cta.ready": "Planning to deploy {title}?",
  "cta.auditDescription": "Discuss your site, technical requirements, and deployment options with the VIVOO team.",
  "cta.getFreeAudit": "Talk to an expert",
  "cta.contactSales": "Contact Sales",
  "cta.learnMore": "LEARN MORE",
  "cta.requestQuote": "REQUEST A QUOTE",
  "cta.downloadGuide": "DOWNLOAD GUIDE",
  "solution.noContent": "No detailed content available for this solution.",
  "faq.title": "Video security system FAQs",
  "faq.q1.question": "Can I monitor cameras remotely?",
  "faq.q1.answer": "Yes. Depending on the system configuration and network connection, authorized users can view cameras and events through an app or management platform.",
  "faq.q2.question": "What should I consider when selecting cameras for a project?",
  "faq.q2.answer": "Define the coverage area, viewing distance, lighting conditions, resolution, analytics requirements, and storage plan.",
  "faq.q3.question": "Can multiple cameras be managed in one system?",
  "faq.q3.answer": "Yes. A centralized management platform can bring devices and events from multiple locations into one interface, subject to system compatibility.",
  "product.relatedProductsTitle": "Explore Related Products",
  "product.relatedProductsDescription": "Explore compatible cameras and devices to complete a video security configuration for your project.",
  "appDownload.title": "Connect mobile app",
  "appDownload.appStore": "Download on the",
  "appDownload.googlePlay": "GET IT ON"
} as const;

export type MessageKey = keyof typeof enMessages;
